/**
 * Cloud mode, from the app's side: tenantdb's client (tenantdb-js),
 * configured as OKANE — the mode and the org last opened kept as `okane.mode`
 * and `okane.org` (the names they have always had), and OKANE's first org
 * called "Personal" when an address gives nothing better.
 *
 * Signing in is a magic link (`requestLink`, then `verifyLink` with the token
 * the link carries) or a passkey; everything else rides on the session cookie
 * the server sets. `VITE_OKANE_API` points the app at another server.
 */
import { CloudError, apiBase as serverOf, createClient } from 'tenantdb/client'

const override = import.meta.env?.VITE_OKANE_API

export const client = createClient({ storagePrefix: 'okane', api: override, defaultOrgName: 'Personal' })

export { CloudError }

/** Where the server is: api.<this host>, or this origin on localhost and IPs. */
export const apiBase = (where = globalThis.location) => serverOf(where, override)

export const {
  files,
  getMode,
  setMode,
  getOrgId,
  setOrgId,
  requestLink,
  verifyLink,
  signOut,
  me,
  passkeysSupported,
  addPasskey,
  removePasskey,
  signInWithPasskey,
  deviceLink,
  startPairing,
  collectPairing,
  lookPairing,
  approvePairing,
  createOrg,
  renameOrg,
  deleteOrg,
  members,
  addMember,
  setRole,
  removeMember,
  chooseOrg,
} = client
